<app-bottom-sheet-title (dismiss)="dismiss()"></app-bottom-sheet-title>
<div class="categories">
    <span class="categories__title">
        <i
            [class]="activeCategory ? activeCategory.icon : 'fas fa-toolbox'"
        ></i>
        {{ activeCategory ? activeCategory.value : 'Toolbox' }}
    </span>
    <div class="categories__items">
        <app-scroll
            #scroll
            [class]="activeCategory ? 'content--wrap' : undefined"
        >
            @for (item of items; track item) {
            <div
                class="item"
                [ngClass]="{'item--block': !!item.icon}"
                (click)="handleItemClick(item)"
            >
                @if (item.icon) {
                <div class="item__icon">
                    <i [class]="item.icon"></i>
                </div>
                }
                <div class="item__text">
                    <span i18n>{{ item.value }}</span>
                </div>
            </div>
            }
        </app-scroll>
    </div>

    <app-scroll-indicator [scroll]="scroll"></app-scroll-indicator>

    @if (activeCategory) {
    <app-button class="back" (click)="handleShowCategories()">
        <i class="fas fa-arrow-left"></i>
        <span i18n>Naar toolbox</span>
    </app-button>
    }
</div>
